export const LOCALES = [
  { code: 'en', name: 'English', language: 'en-US', dir: 'ltr' },
  { code: 'ar', name: 'العربية', language: 'ar-AE', dir: 'rtl' },
  { code: 'he', name: 'עברית', language: 'he-IL', dir: 'rtl' },
  { code: 'ru', name: 'Русский', language: 'ru-RU', dir: 'ltr' },
  { code: 'zh', name: '简体中文', language: 'zh-CN', dir: 'ltr' },
  { code: 'fr', name: 'Français', language: 'fr-FR', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', language: 'de-DE', dir: 'ltr' },
  { code: 'es', name: 'Español', language: 'es-ES', dir: 'ltr' },
  { code: 'it', name: 'Italiano', language: 'it-IT', dir: 'ltr' },
  { code: 'pt', name: 'Português', language: 'pt-PT', dir: 'ltr' },
  { code: 'tr', name: 'Türkçe', language: 'tr-TR', dir: 'ltr' },
] as const;

export type LocaleCode = (typeof LOCALES)[number]['code'];
export type LocaleDir = (typeof LOCALES)[number]['dir'];

export const DEFAULT_LOCALE: LocaleCode = 'en';
export const LOCALE_CODES: readonly LocaleCode[] = LOCALES.map((l) => l.code);

export const LOCALE_COOKIE = 'i18n_locale';
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

// @nuxtjs/i18n default separator for localized route names (`masterclass___ar`).
export const ROUTE_NAME_SEPARATOR = '___';

// Staff tools stay English + LTR regardless of preference (spec §3.7).
export const STAFF_PATH_PREFIXES = ['/admin', '/am'] as const;

// Page files (relative to pages/, no .vue) that get locale-prefixed SEO URLs.
// `**` matches any depth. Everything else is opted out of prefix routing.
export const LOCALIZED_PAGES = [
  'index',
  'international',
  'explore',
  'agents/index',
  'resale',
  'contact',
  'lp/**',
  'masterclass/index',
  'masterclass/[variant]',
  'masterclass/start',
  'projects/**',
  'developers/**',
  'properties/**',
  'p/**',
  'services/**',
] as const;

// English-only copy for pages that never render another locale (/uae, ID-126): other locales need not carry these keys.
export const EN_ONLY_KEY_PREFIXES = ['landing.uae.'] as const;
export const isEnOnlyKey = (key: string): boolean => EN_ONLY_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
